import { db } from "@/fstore";
import cloneDeep from "lodash/cloneDeep";
import forOwn from "lodash/forOwn";
import axios from "axios";
import router from "@/router";
import { returnRandomKey } from "@/utils/randomKey";

const returnNewShowObject = rootState => {
  var key = returnRandomKey(8);
  // Very important. Soundslides 3 shows have 8 digit IDs.
  // Legacy hosting and new hosting have 5 and 10 digits respectively.
  // This will stabilize over time as I recognize that it is a bit weird
  // not to be explicit about where files are stored. Still, I want small ID/URLs.
  var created_at = new Date().getTime();
  var update = {};
  update.key = key;
  update.user = rootState.user.uid;
  update.user_email = rootState.user.email;
  update.deleted = false;
  update.created_at = created_at;
  update.updated_at = created_at;
  update.title = "Untitled Show";
  update.privacyState = "private";
  update.privacySelected = "private";
  update.initialImportComplete = false;
  update.data = {
    slideArray: [],
    overlayArray: [],
    images: [],
    displaySettings: {
      // Defaults go here for all shows.
      globalTransitionType: "crossfade",
      globalTransitionTime: 1,
      audioDurationOverride: 0,
      audioDurationOverrideEnabled: false
    },
    autoTimeEnabled: true
  };
  return update;
};

export default {
  namespaced: true,
  state: {
    redirectAfterFork: true
  },
  getters: {},
  mutations: {},
  actions: {
    duplicateShowByKey({ dispatch }, show_key) {
      var showRef = db.collection("editor_shows").doc(show_key);
      showRef
        .get()
        .then(function(doc) {
          if (doc.exists) {
            console.log("Document data:", doc.data());
            var showData = doc.data();
            dispatch("duplicateShow", showData);
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function(error) {
          console.log("Error getting document:", error);
        });
    },
    duplicateShow({ rootState }, show) {
      // Clone only user's own shows.
      console.log("duplicateShow", show.key);
      var newShowObject = returnNewShowObject(rootState);
      var key = newShowObject.key;
      // Copy data.
      newShowObject.data = cloneDeep(show.data);
      newShowObject.title = `Copy of ${show.title}`;
      // It is CRITICAL that the created_at value never change (due to changes in formats)
      newShowObject.created_at = show.created_at;
      // Additional keys need to be copied (starting with ...)
      // staticImages1600Deployed_
      // staticMp3Deployed_
      // metadataImages_
      // staticMp4Deployed_
      forOwn(show, (v, k) => {
        if (k.startsWith("staticImages1600Deployed_")) {
          newShowObject[k] = v;
        }
        if (k.startsWith("staticMp3Deployed_")) {
          newShowObject[k] = v;
        }
        if (k.startsWith("metadataImages_")) {
          newShowObject[k] = v;
        }
        if (k.startsWith("staticMp4Deployed_")) {
          newShowObject[k] = v;
        }
      });
      console.log(newShowObject);
      // Save to Firestore and redirect.
      db.collection("editor_shows")
        .doc(key)
        .set(newShowObject, { merge: true })
        .then(function() {
          console.log(newShowObject.key);
        });
    },
    forkShow({ rootState, state }, show_object) {
      // Fork a show from any user, if show is forkable.
      // Currently, forking is ONLY used for demo.
      console.log("forkShow");
      var newShowObject = returnNewShowObject(rootState);
      var key = newShowObject.key;
      // Copy data.
      newShowObject.data = cloneDeep(show_object.data);
      newShowObject.user = rootState.user.uid;
      newShowObject.user_email = rootState.user.email;
      newShowObject.forkable = false;
      newShowObject.forked = true;
      if ("fork_source_history" in newShowObject) {
        newShowObject.fork_history_array.push(show_object.key);
      } else {
        newShowObject.fork_history_array = [show_object.key];
      }
      newShowObject.published = false;
      newShowObject.title = show_object.title;
      // It is CRITICAL that the created_at value never change (due to changes in formats)
      newShowObject.created_at = show_object.created_at;
      // Additional keys need to be copied (starting with ...)
      // staticImages1600Deployed_
      // staticMp3Deployed_
      // metadataImages_
      // staticMp4Deployed_
      forOwn(show_object, (v, k) => {
        if (k.startsWith("staticImages1600Deployed_")) {
          newShowObject[k] = v;
        }
        if (k.startsWith("staticMp3Deployed_")) {
          newShowObject[k] = v;
        }
        if (k.startsWith("metadataImages_")) {
          newShowObject[k] = v;
        }
        if (k.startsWith("staticMp4Deployed_")) {
          newShowObject[k] = v;
        }
      });
      console.log(newShowObject);
      // Save to Firestore and redirect.
      db.collection("editor_shows")
        .doc(key)
        .set(newShowObject, { merge: true })
        .then(function() {
          if (state.redirectAfterFork) {
            window.location = "https://soundslides.org/app/editor/" + key;
          }
        });
    },
    forkShowById({ state, dispatch }, show_id) {
      axios
        .get(
          "https://us-central1-soundslides-services.cloudfunctions.net/public/shows/" +
            show_id +
            "/fork/"
        )
        .then(res => {
          var forkData = res.data;
          console.log(res.data);
          state.redirectAfterFork = false;
          dispatch("forkShow", forkData);
        })
        .catch(e => {
          console.log(e);
        });
    },
    newShow({ rootState }) {
      console.log("newShow");
      rootState.showCreationInProgress = true;
      var newShowObject = returnNewShowObject(rootState);
      var key = newShowObject.key;
      console.log(newShowObject);
      // Save to Firestore and redirect.
      db.collection("editor_shows")
        .doc(key)
        .set(newShowObject, { merge: true })
        .then(function() {
          router.push({ name: "show", params: { id: key } });
          rootState.showCreationInProgress = false;
        });
      console.log("new_show: " + key);
    },
    newShowWithMusicTrack({ rootState }, track) {
      console.log("newShow");
      var newShowObject = returnNewShowObject(rootState);
      var key = newShowObject.key;
      console.log(newShowObject);
      // Add the audio track information.
      newShowObject.data.audio = {
        deployed: true,
        duration: track.duration,
        filename: track.filename,
        name: track.title,
        source_id: track.source_id,
        waveformData: true
      };
      newShowObject["staticMp3Deployed_" + track.fieldKey] = {
        duration: track.duration,
        filename: track.filename,
        key: "audio/" + track.source_id + "/" + track.filename,
        source_id: track.source_id
      };
      // Save to Firestore and redirect.
      db.collection("editor_shows")
        .doc(key)
        .set(newShowObject, { merge: true })
        .then(function() {
          router.push({ name: "show", params: { id: key } });
        });
      console.log("new_show: " + key);
    },
    newShowForImport({ rootState, dispatch }) {
      console.log("newShow");
      rootState.showCreationInProgress = true;
      var newShowObject = returnNewShowObject(rootState);
      newShowObject.created_for_import = true;
      var key = newShowObject.key;
      console.log(newShowObject);
      // Save to Firestore and redirect.
      db.collection("editor_shows")
        .doc(key)
        .set(newShowObject, { merge: true })
        .then(function() {
          dispatch("editor/updateCredentialsByKey", key, { root: true });
          router.push({ name: "show-import", params: { id: key } });
          rootState.showCreationInProgress = false;
        });
      console.log("new_show: " + key);
    },
    newShowForImportAndConversion({ rootState, dispatch }) {
      console.log("newShow");
      var newShowObject = returnNewShowObject(rootState);
      newShowObject.created_for_import = true;
      newShowObject.created_for_conversion = true;
      var key = newShowObject.key;
      console.log(newShowObject);
      // Save to Firestore and redirect.
      db.collection("editor_shows")
        .doc(key)
        .set(newShowObject, { merge: true })
        .then(function() {
          dispatch("editor/updateCredentialsByKey", key, { root: true });
          router.push({ name: "show-import", params: { id: key } });
        });
      console.log("new_show: " + key);
    },
    importShow({ rootState, dispatch }, show_object) {
      console.log("importShow");
      var newShowObject = returnNewShowObject(rootState);
      var key = newShowObject.key;
      // Copy data.
      newShowObject.data = show_object;
      // Add source_id to audio, images and slideArray.
      newShowObject.data.images = newShowObject.data.images.map(i => {
        i.source_id = key;
        return i;
      });
      newShowObject.data.slideArray = newShowObject.data.slideArray.map(i => {
        i.source_id = key;
        return i;
      });
      newShowObject.data.audio.source_id = key;
      // Add data for fileMigration lambda function.
      newShowObject.sourceKey = show_object.sourceKey;
      newShowObject.sourceShowLegacy = true; // Noted for admin only.
      newShowObject.sourceFilesMigrated = false;
      // Save to Firestore and redirect.
      db.collection("editor_shows")
        .doc(key)
        .set(newShowObject, { merge: true })
        .then(function() {
          dispatch("callFileMigration", key);
          router.push({ name: "shows" });
          console.log("redirect to editor!!!!", key);
        });
    },
    callFileMigration({ rootState }, key) {
      console.log(rootState.user.uid);
      var fileMigrationEndpoint =
        "https://upload.soundslides.com/files/migrate/" + key + "/";
      //fileMigrationEndpoint = "http://127.0.0.1:5000/files/migrate/" + key + "/";
      axios.get(fileMigrationEndpoint).then(e => {
        console.log(e);
      });
    },
    importComplete({ rootState, dispatch }, obj) {
      console.log(rootState);
      console.log(obj);
      // obj.show is show object.
      var show_object = obj.show;

      // Mark assetsAvailable.
      show_object.data.assetsAvailable = true;
      var show_key = show_object.key;
      var updated_at = new Date().getTime();
      // Update on server.
      show_object.updated_at = updated_at;
      db.collection("editor_shows")
        .doc(show_key)
        .update(show_object)
        .then(function() {
          console.log("updateShowData", "success");
          // Redirect to the editor or to app or video.
          if (show_object.created_for_conversion) {
            router.push({ name: "export-video", params: { id: show_key } });
            return;
          }
          if (show_object.data.displaySettings.noAudio) {
            router.push({
              name: "show-mode",
              params: { id: show_key, mode: "settings" }
            });
            return;
          }
          // In all other situations, redirect to shows.
          dispatch(
            "toastMessage",
            {
              title: "Import Complete",
              variant: "success",
              message: "You can now edit, publish or export your show."
            },
            { root: true }
          );
          router.push({ name: "shows" });
        });
    }
  }
};
